import FormValidation from '../components/FormValidation';

class Contacts {

	constructor() {

		this.toggleForm = this.toggleForm.bind(this);
		this.onFormSubmit = this.onFormSubmit.bind(this);

		this.isFormOpen = false;
		this.$toggler = $('.Contacts__Toggler');
		this.$formContainer = $('.Contacts-container');
		this.$form = this.$formContainer.find('form');

		this.$toggler.on('click', this.toggleForm);

        this.$status = this.$formContainer.find('.Form__Status');
        this.$statusText = this.$formContainer.find('.Form__Status--sent');

        const gaEvent = this.$form.data('ga-event');

		new FormValidation(this.$form, {
            ajax: true,
            inputClass: 'Form__Input',
            inputFocusClass: 'Form__Input--focus',
            inputNotValidClass: 'Form__Input--not-valid',
            submitButtonSelector: '.Form__Submit',
            onSubmit: () => {

                this.$status.removeClass('Form__Status--error');
                this.$form.find('.Form__Status--sending').show();
				this.$form.find('.Form__Status--sent').hide();
                this.$form.find('.Form__Input').removeClass('Form__Input--not-valid');

            },
            onSuccess: (data) => {

				if(this.$form.data('ga-event') && typeof ga !== undefined) {
					console.log('event sent');
					gtag('event', gaEvent);
				} else {
					console.log('event failed');
				}

                this.$form.find('.Form__Status--sent').show();
                this.$form.find('.Form__Status--sending').hide();
                $('.Contacts__Inner').animate({scrollTop: this.$form.find('.Form__Status').offset().top - 100});

            },
            onError: (data) => {

                Object.keys(data.responseJSON).forEach(key => {

                    const message = data.responseJSON[key];
                    const field = this.$form.find(`[name="${key}"]`).closest('.Form__Input');
                    field.find('.Form__InputResponse').html(message);
                    field.addClass('Form__Input--not-valid');

                });

                // this.$form.find('.Form__Status--sent').show();
                this.$form.find('.Form__Status--sending').hide();

                $('.Contacts__Inner').animate({scrollTop: this.$form.find('.Form__Input--not-valid').eq(0).offset().top - 100});

            }
        });

	}

	toggleForm(e) {

		e.preventDefault();

		if(this.isFormOpen) {

		    $('body').removeClass('Contacts--show');
			// this.$formContainer.removeClass('Contacts--show');
			setTimeout(() => {
				this.isFormOpen = false;
				this.$formContainer.hide();
			}, 500);

		} else {

			this.$formContainer.show();
			setTimeout(() => {
				this.isFormOpen = true;
                $('body').addClass('Contacts--show');
				// this.$formContainer.addClass('Contacts--show');
			}, 10);

		}

	}

	onFormSubmit() {

		console.log('on form submit');

	}

}

export default new Contacts();



// WEBPACK FOOTER //
// ./js/layouts/contacts.js